export default "__VITE_ASSET__JG2oq5HL__"